import { ContentGroup } from './contentGroup';
import { Lesson } from './lesson';

export interface Category {
  id: string;
  name: string;
}

export interface AuthorCategory {
  id: string;
  name: string;
}

export interface Goal {
  id: string;
  key: string;
  name: string;
  linkedCategories?: string[];
  linkedPillars?: string[];
  imagePath?: string;
  description?: string;
  disabledCategories?: string[];
  featuredCollection?: ContentGroup[];
  favoritesLessons?: Lesson[];
  emoji?: string | null;
  color?: GoalColor | null;
  order?: number | null;
}

export const GOAL_COLORS = ['blue', 'green', 'pink', 'yellow', 'red'] as const;
export type GoalColor = (typeof GOAL_COLORS)[number];

export interface Pillar {
  id: string;
  name: string;
  imagePath?: string;
}

export interface Promotion {
  id: string;
  offerId: string;
  title: string;
  startDate: number;
  endDate: number;
  description?: string;
  buttonText?: string;
  imagePath?: string;
  timer?: number;
}
